module.exports = __webpack_public_path__ + "edbe2403a7c4f49befd335fb04ad6da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar_Eco8_schwarz_display@2x.png
// module id = 260
// module chunks = 0